import { makeAutoObservable } from 'mobx';
import { CommentFilesInterface } from '../../interfaces/TaskInterface';

export class RichTextStore {
  // Editor content
  content: string = '';
  // Uploaded files
  uploadedFiles: CommentFilesInterface[] = [];
  // Loading state
  isLoading: boolean = false;
  // Emoji dropdown state
  isEmojiDropdownOpen: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  // Setters
  setContent = (content: string) => {
    this.content = content;
  };

  setUploadedFiles = (files: CommentFilesInterface[]) => {
    this.uploadedFiles = files || [];
  };

  // Actions
  addUploadedFiles = (files: CommentFilesInterface[]) => {
    // Spread to ensure new array reference for MobX reactivity
    this.uploadedFiles = [...this.uploadedFiles, ...(files || [])];
  };

  setLoading = (isLoading: boolean) => {
    this.isLoading = isLoading;
  };

  setIsEmojiDropdownOpen = (isOpen: boolean) => {
    this.isEmojiDropdownOpen = isOpen;
  };

  removeUploadedFile = (index: number) => {
    const newFiles = [...this.uploadedFiles];
    newFiles.splice(index, 1);
    this.uploadedFiles = newFiles;
  };

  // Clear all editor state (call this after sending a message or unmounting)
  reset = () => {
    this.content = '';
    this.uploadedFiles = [];
    this.isLoading = false;
    this.isEmojiDropdownOpen = false;
  };
}
